import axios from "axios";
import { createStore, createEffect } from "effector";
import {getCustomUserAgent} from "../../../common/customUserAgent"
import { getUuidAndSession } from "../../../common/localStorage";

export interface ICounter {
  UserCanSend: boolean,
  accountId: number,
  canSend: number,
  counterTypeId: number,
  counter_time: string,
  counter_value: string,
  dateStart: string,
  dateVerification: string,
  first_value: number,
  icon: number,
  id: number,
  is_sync: number,
  last_stamp: string,
  limit_value: number,
  nameType: string,
  ndate2: string,
  period: string,
  place_name: string,
  rec_type: number,
  rec_type_str: string,
  serialNumber: string,
  serviceName: string,
  tariffZone: any,
  tariffZone_n: any,
  tariffZone_p: any,
  tariffs: number,
  unit: string
}
interface ICounterSend{
  accountId:number
  id:number
  value:number
}

export const $currAccCounters = createStore<ICounter[]>([])

export const queryCurrAccCounters = createEffect<number, ICounter[]>();

export const queryUpdateCurrAccCounters = createEffect<ICounter, ICounter[]>();

export const sendCountersValue = createEffect<ICounterSend, string>()

$currAccCounters.on(queryCurrAccCounters.doneData, (_, val) => val);
$currAccCounters.on(queryUpdateCurrAccCounters.doneData, (_, val) => val);

queryUpdateCurrAccCounters.use(async (counter)=>{
  let newCounters = $currAccCounters.getState().filter(e=>e!==counter)
    await axios.post("https://izba.kras-abs.ru/api/v3/counter/values",{
      accountId:counter.accountId,
      ...getUuidAndSession(),
      counterId:counter.id
    },
    {
     headers:{
       "Custom-User-Agent": getCustomUserAgent()
     } 
    }).then(res => {
      Object.assign(counter,{last_stamp: res.data.dateUntil});
      Object.assign(counter,{counter_value: res.data.counter_value});
      newCounters.push(counter)
    })
    return newCounters

})
queryCurrAccCounters.use((accountId: number) =>
  fetch("https://izba.kras-abs.ru/api/v3/counter/list", {
    method: "POST",
    body: JSON.stringify({
      ...getUuidAndSession(),
      "accountId" : accountId
    }),
    headers: {
      "accept": "*/*",
      "content-type": "application/x-www-form-urlencoded; charset=UTF-8",
      "Custom-User-Agent": getCustomUserAgent()
    },
  }).then((res) => res.json())
    .then((res) => {
      let counters = res.counters
      let newCounters:ICounter[] =[]
      counters.forEach((element: ICounter) => {
        axios.post("https://izba.kras-abs.ru/api/v3/counter/values",{
          accountId:accountId,
          ...getUuidAndSession(),
          counterId:element.id
        },
        {
         headers:{
           "Custom-User-Agent": getCustomUserAgent()
         } 
        }).then(res => {//@ts-ignore
          Object.assign(element,{last_stamp: res.dateUntil});
          newCounters.push(element)
        })
        
      });
      return res.counters
    }) //(res?.getCompanies.companies ?? []) as ICompany[])
    .catch((err) => {
      console.log("err_c:", err)
    })
);
sendCountersValue.use((params)=>{
  axios.post("https://izba.kras-abs.ru/api/v3/counter/send",{
          accountId:params.accountId,
          ...getUuidAndSession(),
          counterId:params.id,
          newValue:params.value,
          valueNight:"",
          valuePeak:""
        },
        {headers:{
          "Custom-User-Agent": getCustomUserAgent()
        }}
      ).then(res=>console.log(res))
  return ''
})